// extracted by mini-css-extract-plugin
export default {"wrapper":"BotTableControls_wrapper__EgB8V","controls":"BotTableControls_controls__y761h","clearButton":"BotTableControls_clearButton__UEqcg"};